export default "{\n    \"label\": \"Categories\",\n    \"placeholderText\": \"Select Categories\"\n}\n"